export const config = {
  appName: "Jalodbust",
};
